module.exports = __webpack_public_path__ + "static/media/tti_promotion_subtitle.41322d42.png";